import React, { useState, useEffect } from 'react';
import MedicineListMobile from './medicineListMobile';
import MedicineListWeb from './medicineListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const MedicineListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <MedicineListMobile /> : <MedicineListWeb />;
};

export default MedicineListRouter;
